export default {
      id: "wildberries-usage",
      viewBox: "0 0 48 48",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#wildberries-usage",
      toString: function () {
        return this.url;
      }
    }